<template>
  <div>
    <v-layout text-xs-center wrap>
      <v-flex>
        <Title title="Jeux"></Title>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 offset-sm1 sm10 offset-md1 md10 lg8 offset-lg2 xl6 offset-xl3>
        <v-text-field v-model="search" label="Filtre" placeholder="Darius, PCB, PS1, ..."></v-text-field>
        <template v-for="platform in filteredGames">
          <h2 :key="platform.name" class="mb-3">{{ platform.name }}</h2>
          <v-card :key="'card-' + platform.name" class="mb-3">
            <v-list xl12 class="pa-0">
              <template v-for="(game, index) in platform.children">
                <v-divider :key="'game-' + index" v-if="index > 0"></v-divider>
                <v-list-tile :key="game.id" avatar @click="$emit('go-to-game', game.id)">
                  <v-list-tile-avatar :tile="true" size="54">
                    <img :src="game.cover"/>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="ml-3">{{ game.name }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import Title from '@/components/atoms/Title.vue';
  import _ from 'lodash';

  export default {
    components: {
      Title,
    },
    props: ['games'],
    data() {
      return {
        search: '',
      };
    },
    computed: {
      filteredGames: {
        get() {
          const filter = this.search.trim().toLowerCase();
          if (!filter || filter.length < 3) {
            return this.games;
          }
          return _.cloneDeep(this.games)
            .map(platform => {
              if (platform.name.toLowerCase().indexOf(filter) >= 0) {
                return platform;
              }
              platform.children = platform.children.filter(game => game.name.toLowerCase().indexOf(filter) >= 0);
              return platform;
            })
            .filter(platform => platform.children.length > 0);
        },
      },
    },
  };
</script>
